// extracted by css-extract-rspack-plugin
export default {"warnings":"Wwt9YZ_IAYEScl41","grid":"SNUb_o7XIFxRVW8_","rail":"lxy0I1HSzbkLoT4x","content":"aVqsrtmxd9EQcM20","card":"trxi76GNhEsR0Zi6","infoCard":"x5x7RrCFTn0Pgy0G"};